import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { BaseService } from '../loja/base.service';

@Injectable()
export class GalleryService extends BaseService {

    constructor(protected http: Http) {
        super(http, 'api/v2/client', 'gallery')
    }

    

}


// WEBPACK FOOTER //
// ./src/app/services/gallery/gallery.service.ts